import * as React from 'react';
import { FooterLayout, FooterTop, formatPhone } from '@cian/frontend-e2e-deal-component';
import { TDeviceType, useDeviceType } from '@cian/ui-kit';

import { useApplicationContext } from '../../utils/applicationContext';
import { NBSP } from '../../constants/symbols';
import { ConsultationRequestButtonContainer } from '../ConsultationRequestButtonContainer';

const FOOTER_PADDING: Record<TDeviceType, string> = {
  phone: '40px var(--section-padding-phone)',
  tablet: '40px var(--section-padding-tablet)',
  desktop: '60px var(--section-padding-desktop)',
};

export const PreFooterContainer = () => {
  const { config } = useApplicationContext();
  const deviceType = useDeviceType();

  const phone = config.get<string>('e2e-deal-sale.customSupportContactPhone') || '';
  const email = config.get<string>('e2e-deal-sale.customerSupportContactEmail') || '';
  const cianDealTelegram = config.get<string>('e2e-deal-sale.cianDealTelegram') || '';
  const cianProfessionalsTelegram = config.get<string>('e2e-deal-sale.cianProfessionalsTelegram') || '';

  return (
    <div data-name="PreFooterContainer">
      <FooterLayout
        contentMaxWidth="var(--section-max-width)"
        background="#F4F4F4"
        padding={FOOTER_PADDING[deviceType]}
        topSection={
          <FooterTop
            email={email}
            phone={formatPhone({ phone })}
            phoneDescription={`Будни с${NBSP}07:00 до${NBSP}18:00`}
            actionButton={
              <ConsultationRequestButtonContainer theme="fill_secondary">
                Хочу консультацию
              </ConsultationRequestButtonContainer>
            }
            qrContactCards={[
              {
                title: `Зарабатывайте с Циан: \n главное о сервисах`,
                href: cianDealTelegram,
                description: (
                  <>
                    <a href={cianDealTelegram} target="_blank" rel="noreferrer" data-testid="telegram-cian-deal">
                      Telegram-канал
                    </a>{' '}
                    для консультаций
                  </>
                ),
                qrCodeSrc:
                  'https://cdn.cian.site/frontend/e2e-form-assets/promo/images/cian_deal_telegram_channel_qr_x2.png',
              },
              {
                title: 'Циан для профи',
                href: cianProfessionalsTelegram,
                description: (
                  <>
                    <a
                      href={cianProfessionalsTelegram}
                      target="_blank"
                      rel="noreferrer"
                      data-testid="telegram-cian-professionals"
                    >
                      Telegram-канал
                    </a>{' '}
                    с новостями сервиса
                  </>
                ),
                qrCodeSrc:
                  'https://cdn.cian.site/frontend/e2e-form-assets/promo/images/cian_professionals_telegram_channel_qr_x2.png',
              },
            ]}
          />
        }
      />
    </div>
  );
};
